<template lang="pug">
  sui-card
    sui-image(:src="player.headshot")
    sui-card-content
      sui-card-header {{ player.gamertag }}
      sui-card-meta {{ player.fullName }}

    sui-card-content(
      v-if="player.birthdate"
      extra)
      sui-icon(name="birthday cake")
      | {{ birthdate }}
</template>

<script>
import { DateTime } from 'luxon';

export default {
  name: 'PlayerCard',
  props: {
    player: {
      required: true,
    },
  },
  computed: {
    birthdate() {
      return DateTime.fromISO(this.player.birthdate).toFormat('MMMM d');
    },
  },
};
</script>
